var React = require('react');

function ClockInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.0645 23C5.98932 23 1.06445 18.0751 1.06445 12C1.06445 5.92487 5.98932 1 12.0645 1C18.1396 1 23.0645 5.92487 23.0645 12C23.0645 18.0751 18.1396 23 12.0645 23ZM12.0645 21C17.035 21 21.0645 16.9706 21.0645 12C21.0645 7.02944 17.035 3 12.0645 3C7.09389 3 3.06445 7.02944 3.06445 12C3.06445 16.9706 7.09389 21 12.0645 21ZM13.0645 5V11.5L16.6645 14.2L15.4645 15.8L11.0645 12.5V5H13.0645Z","fill":"#C7D5D9"}));
}

ClockInline.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none","role":"img","aria-label":""};

module.exports = ClockInline;

ClockInline.default = ClockInline;
